// extracted by mini-css-extract-plugin
export default {"tooltip":"Tn-z","sharingV2":"Un-z","sharingIconsV2":"Vn-z","links":"Wn-z","link":"Xn-z","facebookV2":"Yn-z","twitterV2":"Zn-z","pinterestV2":"_n-z"};